import { render, staticRenderFns } from "./NewSparepart.vue?vue&type=template&id=7311532c"
import script from "./NewSparepart.vue?vue&type=script&lang=js"
export * from "./NewSparepart.vue?vue&type=script&lang=js"
import style0 from "./NewSparepart.vue?vue&type=style&index=0&id=7311532c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports